import { useFormContext } from 'react-hook-form'

import { getIconName } from '@/shared/lib/get-icon-name'
import { AppsflyerEvent, sendAppsflyer } from '@/shared/metrics'
import { Cell, Icon } from '@/shared/ui'

import type { TFormValues } from '../../model'

import styles from './driver-recharge-radio.module.scss'

type TDriverRechargeRadioProps = {
    openModal: () => void
    ref: React.Ref<HTMLDivElement>
}

export const DriverRechargeRadio = ({
    openModal,
    ref,
}: TDriverRechargeRadioProps): React.ReactNode => {
    const { watch } = useFormContext<TFormValues>()

    return (
        <div ref={ref} className={styles['driver-recharge-radio']} id='selector-tooltip'>
            <Cell
                data-test-id='driver-recharge-method'
                onClick={() => {
                    sendAppsflyer(AppsflyerEvent.finance_topup_method_click, {})
                    openModal()
                }}
            >
                <div className={styles['driver-recharge-radio__item']}>
                    <div className={styles['driver-recharge-radio__item-icon']}>
                        <Icon icon={getIconName(watch('paymentMethod').id)} size={24} />
                    </div>
                    <span
                        className={styles['driver-recharge-radio__item-text']}
                        data-test-id='driver-recharge-method-title'
                    >
                        {watch('paymentMethod').title}
                    </span>
                </div>
            </Cell>
        </div>
    )
}
